import { createStore } from '@stencil/store';

import { filterQuestionsCollection } from '../utils/utils.question';

// These questions are in the ones we get from the API, but they are Boolean instead of Enum.
// So override to be Enum with correct enumChoices
const staticQuestions = [
  {
    questionId: 'qp/83',
    questionType: 'Boolean',
    isRadioInputStyle: true,
    label: 'Are you the original owner?',
    enumChoices: ['Yes', 'No'],
    enumValues: [true, false],
    isRequired: true,
    dataTestId: 'originalOwnerQuestion',
  },
  // This question is just copied and pasted from the API to put it in the correct place. We want this as the second question
  {
    questionId: 'qp/124',
    questionType: 'Enum',
    label: 'Has it had any accidents or issues that may appear on a vehicle history report (Carfax, AutoCheck, etc)?',
    enumChoices: ['Yes', 'No', 'Not Sure'],
    dataTestId: 'accidentsIssuesQuestion',
  },
  {
    questionId: 'qp/81',
    questionType: 'Boolean',
    isRadioInputStyle: true,
    label: 'Has this vehicle been to an auto auction in the last 45 days?',
    enumChoices: ['Yes', 'No'],
    enumValues: [true, false],
    isRequired: true,
    dataTestId: 'autoAuctionQuestion',
  },
  {
    questionId: 'qp/125',
    questionType: 'Boolean',
    isRadioInputStyle: true,
    label: 'Has this car been used as a rental car?',
    enumChoices: ['Yes', 'No'],
    enumValues: [true, false],
    isRequired: true,
    dataTestId: 'rentalQuestion',
  },
];

const questionsToAskById = []; // not all questions in the payload are surfaced.

const initialState = {
  questionsHistory: [],
  questions: [], // passed to the components
};

const { state, on, onChange, reset } = createStore(initialState);

// filter questions down to only those within scope, add static questions in.
onChange('questionsHistory', (questionsHistory) => {
  state.questions = [...staticQuestions, ...filterQuestionsCollection(questionsHistory, questionsToAskById)];
});

export { initialState, on, onChange, state, reset };
export default state;
